"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosterMessage = void 0;
const utils_1 = require("../utils");
const base_html_1 = require("./base-html");
class RosterMessage {
    get replyTo() {
        return this.sentBy.email;
    }
    get _fromString() {
        return (0, utils_1.formatDate)(this.from);
    }
    get _toString() {
        return (0, utils_1.formatDate)((0, utils_1.dateAdd)(this.to, { days: -1 }));
    }
    constructor(vals) {
        Object.assign(this, vals);
    }
    get recipient() {
        return this.employee.email;
    }
    get title() {
        return `${this.venue.name} - Dienstplan ${this._fromString} bis ${this._toString}`;
    }
    get text() {
        return `
Hallo ${this.employee.firstName},

Es ist ein neuer Dienstplan für die Woche vom ${this._fromString} bis ${this._toString} verfügbar!
Diesen kannst du über folgenden Link einsehen:

${this.url}

Liebe Grüße,
${this.sentBy.name}
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.employee.firstName},`)}

            ${(0, base_html_1.paragraph)(`Es ist ein neuer Dienstplan für die Woche vom <strong>${this._fromString}</strong> bis <strong>${this._toString}</strong> verfügbar!`)}

            ${(0, base_html_1.button)("Dienstplan Einsehen", this.url)}

            ${(0, base_html_1.paragraph)(`
                Liebe Grüße,<br>
                ${this.sentBy.name}
            `)}
        `);
    }
}
exports.RosterMessage = RosterMessage;
//# sourceMappingURL=roster.js.map